import { api } from '@/api/api-client.config.ts';
import { useMutation } from '@tanstack/react-query';

const postForceCache = ({ tenants }: { tenants: string[] }) =>
  api.post(`/admin/pickems/force-cache`, {
    tenants,
  });

export const useForceCacheMutation = () => {
  return useMutation({
    mutationKey: ['postForceCache'],
    mutationFn: postForceCache,
  });
};
